import React, { useContext, useEffect } from 'react';

/** components */
import ReviewContent from '../components/ReviewContent/ReviewContent';
import Layout from '../components/common/Layout';

/** context */
import { UserContext } from '../context/UserContext';
import rudderanalytics from '../service/rudderstack';

const Review = () => {
  const { loading } = useContext(UserContext);

  useEffect(() => {
    rudderanalytics.page('Review');
  }, []);

  return (
    <Layout>{!loading ? <ReviewContent /> : <div className="loading">Loading...</div>}</Layout>
  );
};

export default Review;
